import organization from './config-organization';
import position from './config-position';
import WizTableForm from "../wizTableForm";

let organizationConfig = organization(this, { apiParams: { state: 1} });
let positionConfig = position(this, { apiParams: { state: 1 } });

const columns = () => {
  return [
    {
      title: '账号',
      name: 'searchUserName',
      dataIndex: 'searchUserName',
      searchItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      dataIndex: 'userName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '姓名',
      name: 'searchFullName',
      dataIndex: 'searchFullName',
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      dataIndex: 'fullName',
      tableItem: {
        width: 120
      }
    },
   /*  {
      title: '证件号码',
      name: 'idCard',
      dataIndex: 'idCard',
      tableItem: {
        width: 180
      }
    }, */
    {
      title: '手机号',
      name: 'searchMobile',
      dataIndex: 'searchMobile',
      searchItem: {}
    },
    {
      title: '组织名称',
      name: 'orgId',
      dataIndex: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
        initialValue: undefined,
      }
    },
    {
      title: '岗位名称',
      name: 'positionIds',
      dataIndex: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm
      }
    },
    {
      title: '手机号',
      name: 'mobile',
      dataIndex: 'mobile',
      tableItem: {
        width: 150
      }
    },
    {
      title: '组织名称',
      name: 'orgName',
      dataIndex: 'orgName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '组织编码',
      name: 'orgCode',
      dataIndex: 'orgCode',
      tableItem: {
        width: 160
      }
    },
    {
      title: '岗位名称',
      name: 'positionName',
      dataIndex: 'positionName',
      tableItem: {
        width: 150
      }
    },
  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'userIdentityManagement/getUserIdentityDetailPage',
    ...api
  }
};

const userIdentity = (self, api) => {
  if (api?.apiParams?.isNotAuth) {
    organizationConfig = organization(this, { apiParams: { state: 1, isNotAuth: true} });
    positionConfig = position(this, { apiParams: { state: 1, isNotAuth: true} });
  }

  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'personId',
    rowTitle: 'userName',
    rowName: 'fullName',
    columns: columns(),
    tableApi: tableApi(api),
    setData: (list)=>{
      let listNew = []
      list && list.length && list.forEach(element => {
          if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
              element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
            }
          listNew.push(element);
      });
      return listNew;
  }
  }
};

export default userIdentity
